import React from "react";

interface Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: React.ReactNode;
  variant: "lightBlue" | "primary" | "secondary";
}

const LouiseButton = (props: Props) => {
  const { className, variant, ...rest } = props;

  const variantBase: { [key: string]: string } = {
    lightBlue: "tw-bg-blue-100 tw-text-blue-700",
    primary: "tw-bg-primary tw-text-white",
    secondary: "tw-bg-gray-300 tw-text-gray-600"
  };

  return (
    <button
      {...rest}
      className={`tw-px-5 tw-py-2 tw-shadow tw-justify-center tw-items-center tw-inline-flex tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal tw-border-none tw-ring-0 ${
        className ? className : "tw-rounded-md"
      } ${variantBase[variant]} disabled:tw-bg-gray-300 disabled:tw-text-white`}
    >
      {props.children}
    </button>
  );
};

export default LouiseButton;
